module.exports = __webpack_public_path__ + "img/solution-gk.c50e1ea4.jpg";